import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { classNames } from "../../../helpers";
import HoverVoterCardIcon from "./hoverVoterCardIcon";

import { useStore } from "../../../helpers";

import {
    ExpandButton,
    VoterAdditionalInfo,
    VoterDetails,
    VoterId,
    VoterInfo,
} from "../Voters";

import VoterAddress from "./VoterAddress";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { safe_get } from "../../../report-visuals";
import HoverSchemeCheckIcon from "./hoverSchemeCheckIcon";
import { ServiceExpandButton } from "./Srrequestbutton";

export const VoterCard = observer((props: any) => {
    const { voterdata } = props;
    const rootStore = useStore();

    const { voterListStore, projectStore, aiGentoolStore } = rootStore;
    const { edit_voter_modal } = voterListStore;

    const { projectid } = useParams();

    const voterid = safe_get(voterdata, "id", null);

    const [isExpanded, setExapnded] = useState(false);
    const [requestExpanded, setRequestExapnded] = useState(false);
    const [family, setFamily] = useState(null);
    const [requests, setRequests] = useState(null);
    const [isHovered, setIsHovered] = useState(false);

    const projectProperties = projectStore.getProjectProperty(
        "project_state",
        {}
    );

    const voterCheck = safe_get(projectProperties, "voterCheck", null);

    const toggleExapnd = async () => {
        const next = !isExpanded;
        setExapnded(next);

        if (next) {
            try {
                const payload = {
                    projectid: parseInt(projectid),
                    voterid: voterid,
                };

                const res = await voterListStore.getVoterFamily(payload);

                if (res.status === 200) {
                    setFamily(res.data.family);
                }
            } catch (err) {
                toast.error("Failed to fetch family info");
                console.error(err);
            }
        }
    };

    const toggleRequest = async () => {
        const next = !requestExpanded;
        setRequestExapnded(next);

        if (next) {
            try {
                const payload = {
                    projectid: parseInt(projectid),
                    voterid: voterid,
                };

                const res =
                    await voterListStore.getVoterServiceRequest(payload);

                if (res.status === 200) {
                    setRequests(res.data.service_request);
                }
            } catch (err) {
                toast.error("Failed to fetch service request info");
                console.error(err);
            }
        }
    };

    const handleEditIconClick = () => {
        voterListStore.update_edit_voter_modal(!edit_voter_modal);
        voterListStore.update_active_voter(voterdata);
    };

    const handleSchemeCheck = async () => {
        if (!voterCheck) return;

        aiGentoolStore.setActiveEligibiltyDetails(null);
        voterListStore.update_active_voter(voterdata);

        try {
            const payload = {
                projectid: parseInt(projectid),
                voterid: voterid,
            };

            const res =
                await aiGentoolStore.check_voter_eligible_schemes(payload);

            if (res?.data?.status === true) {
                voterListStore.update_voter_eligible_scheme_list(
                    res?.data || []
                );

                voterListStore.update_voter_scheme_profile(
                    res?.data?.scheme_profile || {}
                );

                voterListStore.update_voter_eligible_schemes(true);
            } else {
                voterListStore.update_info_scheme(true);
                voterListStore.update_voter_eligible_scheme_list([]);
            }
        } catch (error) {
            toast.error("Failed to fetch scheme eligibility");
            console.error(error);
        }
    };

    const single = Array.isArray(voterdata) ? voterdata[0] : voterdata;
    const profile = single?.profile || single || {};

    return (
        <>
            <div
                key={
                    Array.isArray(voterdata)
                        ? voterdata[0]?.voterid || voterdata[0]?.id
                        : voterdata?.voterid || voterdata?.id
                }
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                className={classNames(
                    isHovered ? "relative" : "static",
                    "hover-votercard-shadow cursor-pointer break-inside-avoid-column self-start rounded-3xl bg-white"
                )}
            >
                <VoterId
                    voterData={single}
                    id={profile.voterid}
                    hover={isHovered}
                />

                <VoterInfo
                    name={profile.name_eng}
                    localname={profile["name_reg"]}
                />

                <VoterDetails
                    serialno={profile.serialno}
                    booth={single.part}
                    gender={profile.gender}
                    age={profile.age}
                />

                <VoterAdditionalInfo
                    phone={single.phone}
                    houseno={profile.house}
                    voterData={single}
                    availability={single?.["availability"]}
                    which_city={single?.["which_city"]}
                />

                <VoterAddress
                    address={profile.address}
                    relationship={profile.relationship_eng}
                    relation={profile.relation_name_eng}
                    caste={single.caste}
                    dob={profile.dob}
                    expand={isExpanded}
                    requests={requestExpanded}
                    family={family}
                    service_request={requests}
                    poll={profile["poll_reg"]}
                />

                <div className="flex overflow-hidden rounded-b-3xl border-t border-gray-200 bg-gray-300">
                    <div className="flex-1">
                        <ExpandButton onExapnd={toggleExapnd} />
                    </div>

                    <div className="flex-1 border-l border-gray-200">
                        <ServiceExpandButton
                            isExpanded={requestExpanded}
                            onExapnd={toggleRequest}
                        />
                    </div>
                </div>

                {isHovered && (
                    <HoverVoterCardIcon onEdit={handleEditIconClick} />
                )}

                {voterCheck && isHovered && (
                    <HoverSchemeCheckIcon onEdit={handleSchemeCheck} />
                )}
            </div>
        </>
    );
});
